<div class="controls-container w-100 d-flex flex-row justify-content-center">
    <app-round-transparent-icon-button type="toggle" [activeIcon]="micOffIcon" [inactiveIcon]="micIcon"
        (onClick)="onMicMute($event)"></app-round-transparent-icon-button>
    <app-round-transparent-icon-button class="m-r-10 m-l-10" type="normal" [inactiveIcon]="hangUpIcon"
        [inactiveIconStyle]="{
      stroke: 'red',
      color: 'red'
    }" (onClick)="onHangUp()"></app-round-transparent-icon-button>
    <app-round-transparent-icon-button class="m-r-10" type="toggle" [activeIcon]="camOffIcon" [inactiveIcon]="camIcon"
        (onClick)="onCameraMute($event)">
    </app-round-transparent-icon-button>
    <app-round-transparent-icon-button type="normal" [activeIcon]="pinIcon" [inactiveIcon]="pinIcon"
        (onClick)="onPin($event)">
    </app-round-transparent-icon-button>
</div>